import { render } from "./OverdueWarning.vue?vue&type=template&id=2be28322"
import script from "./OverdueWarning.vue?vue&type=script&lang=js"
export * from "./OverdueWarning.vue?vue&type=script&lang=js"

import "./OverdueWarning.vue?vue&type=style&index=0&id=2be28322&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__